module.exports = __webpack_public_path__ + "public/img/chongzhi.723f08af.png";